export default {
  status: '',
  token: window.localStorage.getItem('token') || '',
  user: {}
}
